import qs from "qs";

/* 
  Replaces the current query string value with the new provided value 
  without triggering a page refresh. Manually trigger a popstate event
  so the useReactPath hook recognizes the url change. 
*/
const setQueryStringWithoutPageReload = (qsValue: any) => {
  const newURL = `${window.location.protocol}//${window.location.host}${window.location.pathname}${qsValue}`;
  const state = { path: newURL };
  window.history.pushState(state, "", newURL);
  const popStateEvent = new PopStateEvent("popstate", { state: state });
  dispatchEvent(popStateEvent);
};

interface QueryParamObj {
  [key: string]: any;
}

const filterNonNull = (obj: QueryParamObj) => {
  return Object.fromEntries(Object.entries(obj).filter(([k, v]) => v));
};

/* 
  Updates the query string parameters only for the provided key, 
  keeping the remaining parameters intact.
*/
const setQueryStringValue = (
  newQueryToAdd: QueryParamObj,
  queryString = window.location.search
) => {
  const values = qs.parse(queryString, { ignoreQueryPrefix: true });
  const newQsValue = qs.stringify(
    filterNonNull({ ...values, ...newQueryToAdd })
  );
  setQueryStringWithoutPageReload(`?${newQsValue}`);
};

/* Returns the query string value for the provided key. */
const getQueryStringValue = (
  key: string,
  queryString = window.location.search
) => {
  const values = qs.parse(queryString, { ignoreQueryPrefix: true });
  const extractedValue = values[key];
  const stringifiedValue = JSON.stringify(extractedValue);
  return typeof extractedValue == "string" ? extractedValue : stringifiedValue;
};

export { getQueryStringValue, setQueryStringValue };
